import { RootState } from "@src/store";
import { ICoreZonesInitialState } from "./types";
import { createSelector } from "@reduxjs/toolkit";

const CoreZonesReducer = (state: RootState): ICoreZonesInitialState => state.CoreZonesReducer;

export const selectDisplayZones = createSelector(
  [CoreZonesReducer],
  (state) => state?.displayZones ?? true
);